module.exports = {
    controller: customsOfficeSearchController,
    templateUrl: 'customs-offices/components/customs-office-search-page.html'
};

customsOfficeSearchController.$inject = [
    '$analytics', 
    '$routeParams',
    'customsOfficeDataService',
];

function customsOfficeSearchController(
    $analytics,
    $routeParams,
    customsOfficeDataService
) {
    var vm = {
        $onInit: attached,
        $onDestroy: detached,
        isLoading: false,
        loadNew: loadNew,
        service: customsOfficeDataService,
        referenceNumber: $routeParams.referenceNumber,
    };

    return vm;

    function attached() {
        $analytics.pageTrack('/customs-office-search');
    }

    function detached() {
    }

    function loadNew() {
    }

    function init() {
    }

}